import { useNavigate } from 'react-router-dom';
import { Card } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import DistrictForm from '../components/DistrictForm';
import { useCreateDistrict } from '../hooks/useDistrictMutations';
import type { DistrictFormData } from '@/shared/types';

export default function DistrictCreatePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const mutation = useCreateDistrict();

  const handleSubmit = (data: DistrictFormData) => {
    mutation.mutate(data, { onSuccess: () => navigate('/districts') });
  };

  return (
    <div>
      <PageHeader back title={t('districts.addNew')} />
      <Card style={{ marginTop: 16 }}>
        <DistrictForm onSubmit={handleSubmit} isLoading={mutation.isPending} />
      </Card>
    </div>
  );
}
